import {getCurrentUserId} from './auth_utils';

const seenInMemory = new Set<string>();
export const resultVisitKey = (sessionId: string) =>
    `farewise:results-seen:${getCurrentUserId() || 'guest'}:${sessionId}`;

export function hasSeenResults(key: string): boolean {
    try { return seenInMemory.has(key) || localStorage.getItem(key) === 'true'; }
    catch { return seenInMemory.has(key); }
}

export function markResultsSeen(key: string): void {
    seenInMemory.add(key);
    try { localStorage.setItem(key, 'true'); } catch { /* Keep this visit in memory if storage is unavailable. */ }
}
